
export default function Video() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            화악산 포도즙 이야기
          </h2>
          <p className="text-lg text-gray-600">
            청정 자연에서 정성으로 만드는 과정을 영상으로 만나보세요
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-2xl shadow-2xl"
              src="https://www.youtube.com/embed/yl3ZZtNdFSc"
              title="화악산 포도즙 홍보 영상"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            화악산의 청정 자연과 정성스러운 제조 과정을 직접 확인하세요
          </p>
        </div>
      </div>
    </section>
  );
}
